import { AxiosResponse } from 'axios';
import {
  LoginRequestPayload,
  RegisterRequestPayload,
} from '../../redux/auth/action';
import axiosInstance from '../../utils/axiosInstance';

interface LoginResponse {
  token: string;
  refreshToken: string;
  user: JSON;
}

export interface UpdateUserRequestDto {
  email?: string;
  phone?: string;
  fullName?: string;
  position?: string;
  password?: string;
}

export interface UserUpdateResponse {
  userId: number;
  username: string;
  email: string;
  phone: string;
  employeeId: number;
  fullName: string;
  position: string;
}

export interface ChangePasswordRequestDto {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

export const loginUser = async (
  payload: LoginRequestPayload
): Promise<AxiosResponse<LoginResponse>> => {
  try {
    const response = await axiosInstance.post('/auth/login', payload);
    const { token, refreshToken, user } = response.data;
    // Store token and user in local storage if needed
    localStorage.setItem('token', token);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('user', JSON.stringify(user));
    return response;
  } catch (error: any) {
    // if (error.response && error.response.data) {
    //   throw new Error(error.response.data);
    // }
    throw error;
  }
};

export const registerUser = async (
  payload: RegisterRequestPayload
): Promise<AxiosResponse<LoginResponse>> => {
  try {
    return await axiosInstance.post('/auth/register', payload);
  } catch (error: any) {
    throw error;
  }
};

export const logout = async (): Promise<void> => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
};

export const refreshToken = async (
  refreshToken: string
): Promise<AxiosResponse<LoginResponse>> => {
  try {
    const response = await axiosInstance.post('/auth/refresh-token', {
      refreshToken,
    });
    const { token, refreshToken: newRefreshToken, user } = response.data;
    // Update token and refreshToken in local storage
    localStorage.setItem('token', token);
    localStorage.setItem('refreshToken', newRefreshToken);
    localStorage.setItem('user', JSON.stringify(user));
    return response;
  } catch (error: any) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data);
    }
    throw error;
  }
};

export const updateUserInfo = async (
  userId: number,
  payload: UpdateUserRequestDto
): Promise<AxiosResponse<UserUpdateResponse>> => {
  try {
    return await axiosInstance.put(`/auth/update/${userId}`, payload);
  } catch (error: any) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data);
    }
    throw error;
  }
};

export const changePassword = async (
  payload: ChangePasswordRequestDto
): Promise<AxiosResponse<string>> => {
  try {
    return await axiosInstance.post('/auth/change-password', payload);
  } catch (error: any) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data);
    }
    throw error;
  }
};
